import React from "react";
import { useNavigate } from "react-router-dom";
import Btn from "../../Components/Btn";
import { Call } from "../../Utils/icons";
import "./style.scss";
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="not-found">
        <div>
          {" "}
          <header></header>
          <nav>
            <div className="logo">
              <img src={require("../../Assets/icons/logo-404.png")} />
            </div>
            <div className="contact-us">
              <a href="tel:02174853" className="call-center">
                <span
                  className="fs-13 lh-22 fw-500"
                  style={{ whiteSpace: "nowrap" }}
                >
                  021-74853
                </span>
                <span className="icon-call">
                  <Call />
                </span>
              </a>
            </div>
          </nav>
        </div>

        <div className="hero-not-found">
          <div className="image">
            <img src={require("../../Assets/images/not-found.png")} />
          </div>
          <p className="text-main text-center fs-12 fw-600 lh-20">
            صفحه‌ای که به دنبال آن می‌گردید وجود ندارد
          </p>
          <p className="text-main text-center fs-12 fw-600 lh-20">
            در صورتیکه فکر می‌کنید اشتباهی اتفاق افتاده است با پشتیبانی در تماس
            باشید
          </p>
          <div className="btn-wrapper">
            <Btn
              onClick={() => {
                navigate(-1);
              }}
              text={() => {
                return "بازگشت به صفحه قبل";
              }}
            />
          </div>
        </div>
        <footer className="fs-11 lh-19 fw-600 text-main">
          تمامی حقوق این سامانه برای فراز اس‌ام‌اس محفوظ می‌باشد.
        </footer>
      </div>
    </>
  );
};

export default NotFound;
